import moment from "moment"
import { FC, useCallback } from "react"
import { IHallBookingBill } from "src/domain/entities"
import { hallBookingBillUpdateService } from "src/domain/services/hallBookingBill/hallBookingBillUpdateService"
import { useAuth } from "src/hooks/useAuth"
import { FormikOnSubmit } from "src/utils/types"
import { IHallBookingBillUpdateFormFields } from "."
import { HallBookingBillUpdateDrawerFormView } from "./HallBookingBillUpdateDrawerFormView"

interface Props {
	hallBookingBill: IHallBookingBill
	onSuccess: () => void
	isOpen: boolean
	onClose: () => void
}

export const HallBookingBillUpdateDrawerFormController: FC<Props> = ({
	hallBookingBill,
	onSuccess,
	isOpen,
	onClose,
}) => {
	const { token } = useAuth()

	const handleSubmit = useCallback<FormikOnSubmit<IHallBookingBillUpdateFormFields>>(
		async (values, { setErrors }) => {
			try {
				await hallBookingBillUpdateService(
					{
						id: hallBookingBill.id,
						update: {
							billNo: values.billNo,
							date: moment(values.date).valueOf(),
							electricity: {
								previousReading: values.electricity.previousReading,
								currentReading: values.electricity.currentReading,
								amount: values.electricity.amount,
							},
							gas: {
								previousReading: values.gas.previousReading,
								currentReading: values.gas.currentReading,
								amount: values.gas.amount,
							},
						},
					},
					token,
				)
				onSuccess()
				onClose()
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({ billNo: message })
			}
		},
		[hallBookingBill.id, token, onSuccess, onClose],
	)

	return (
		<HallBookingBillUpdateDrawerFormView
			hallBookingBill={hallBookingBill}
			handleSubmit={handleSubmit}
			isOpen={isOpen}
			onClose={onClose}
		/>
	)
}
